import "@tento-ui/components/rich-text-editor/rich-text-editor";
import "@tento-ui/brand/blog/blog-newsroom-post-pagelet";
import "@tento-ui/components/squircle/squircle";

import { BlogNewsroomPostPagelet } from "@tento-ui/brand/blog/blog-newsroom-post-pagelet";
import { RichTextEditor } from "@tento-ui/components/rich-text-editor/rich-text-editor";
import { Squircle } from "@tento-ui/components/squircle/squircle";
import { Typography } from "@tento-ui/ui/typography";
import type { BlogPost } from "../blog-data";
import type {
  BlogPostPage,
  BlogPostRoute,
} from "../blog-variant";

export const newsroomPostRoute: BlogPostRoute = {
  make(post: BlogPost, _delegate: BlogPostPage.Delegate): HTMLElement {
    const $category = Typography.p(categoryLabel(post.category));
    $category.classList.add("newsroom-category");

    const $heroImg = document.createElement("img");
    $heroImg.src = post.heroImage;
    $heroImg.alt = post.title;
    $heroImg.slot = "clipped";
    $heroImg.style.width = "100%";
    $heroImg.style.height = "100%";
    $heroImg.style.objectFit = "cover";
    $heroImg.style.display = "block";

    const $hero = Squircle.makeWith({
      radius: 20,
      smoothing: 0.6,
      fill: "transparent",
    });
    $hero.assignStyles({ width: "100%", height: "460px" });
    $hero.appendChild($heroImg);

    const $content = RichTextEditor.make() as RichTextEditor;
    $content.bind({ markdown: post.content ?? "", editable: false });

    return BlogNewsroomPostPagelet.makeWith({
      category: $category,
      heroImage: $hero,
      content: $content,
    });
  },
  bind(pagelet: HTMLElement, _post: BlogPost, _delegate: BlogPostPage.Delegate): HTMLElement {
    return pagelet;
  },
};

function categoryLabel(category: BlogPost["category"]): string {
  if (!category) return "";

  const text = category.replace(/-/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
